<script setup lang="ts">
import type {Partner} from '~/types/legacy'
import type {Populated} from '~/types/populated'

const props = withDefaults(
  defineProps<{
    partners: Populated<Partner>[]
    title?: boolean
  }>(),
  {
    title: true,
  }
)
</script>
<template>
  <div>
    <Paragraph v-if="title" size="normal" weight="normal" align="center" class="!text-gray-400">
      {{ $t('home.partners_title') }}
    </Paragraph>

    <div class="mt-4 grid grid-cols-2 flex-wrap items-center justify-center gap-8 lg:flex lg:gap-12">
      <template v-for="partner in props.partners" :key="partner.name">
        <NuxtImg
          v-if="partner.logo"
          v-bind="resolveMediaProps(partner.logo)"
          :height="partner.logo?.height ?? undefined"
          :width="partner.logo?.width ?? undefined"
          loading="lazy"
          class="mx-auto max-h-[15rem] max-w-[7.5rem] object-contain lg:mx-0"
        />
      </template>
    </div>
  </div>
</template>
